/* eslint-disable no-console */

import { AsyncButton, Page } from "shared/react";
import { DB } from "./util/db.js";

export function TestPage(): React.ReactElement | null {
	return (
		<Page>
			<AsyncButton
				onClick={async () => {
					await DB.updateItem("list", "yQoWYSQxJgMDSdlOFhrd", { "+[]items": "challenge:YeG9O4004F7pTK6npUUV" });
				}}
			>
				CLICK
			</AsyncButton>
		</Page>
	);
}
